import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/setting/organization',
  title: '组织架构管理',
  component: dynamicWrapper(app, [import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);
